module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "runmode"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showComponent),
      expression: "showComponent"
    }]
  }, [_c('div', {
    staticClass: "goback"
  }, [(_vm.backDisabled) ? _c('div', {
    staticClass: "back"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backPathstep
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.goDisabled) ? _c('div', {
    staticClass: "go"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goPathstep
    }
  })]) : _vm._e()]), _vm._v(" "), _c(_vm.currentView, {
    tag: "component",
    attrs: {
      "pathstep": _vm.pathstepData,
      "productLanguage": _vm.productInfo.language,
      "scriptSystems": _vm.levelJson.scriptSystems,
      "changeTileFlag": _vm.changeTileFlag,
      "lang": _vm.productInfo.language,
      "isScrollIconVisible": _vm.isScrollIconVisible
    },
    on: {
      "updateLearnedGroup": _vm.updateLearnedGroup,
      "endAct": _vm.endAct,
      "stopAct": _vm.stopAct,
      "showMicrophoneErrorDialog": _vm.showMicErrorDialog,
      "mounted": _vm.startBindView,
      "hintMouseDown": _vm.hintMouseDown,
      "hintMouseUp": _vm.hintMouseUp,
      "hintMouseMove": _vm.hintMouseMove,
      "changeTile": _vm.changeTile,
      "showScrollIcon": _vm.showScrollIcon
    }
  })], 1)]), _vm._v(" "), (_vm.showCompletionView) ? _c('ActivityCompletion', {
    attrs: {
      "lessonIndex": _vm.completionLessonIndex,
      "pathTitle": _vm.completionPathTitle,
      "answerRate": _vm.completionAnswerRate,
      "ok": _vm.completionOk,
      "ng": _vm.completionNg,
      "skip": _vm.completionSkip,
      "total": _vm.completionTotal,
      "nextUnitNo": _vm.completionNextUnitNo,
      "nextUnitTitle": _vm.completionNextUnitTitle,
      "nextLessonIndex": _vm.completionNextLessonIndex,
      "nextPathTitle": _vm.completionNextPathTitle
    },
    on: {
      "clickButton": _vm.clickButtonCompletion
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSectionDialogView) ? _c('SectionDialog', {
    attrs: {
      "answerRate": _vm.completionAnswerRate,
      "ok": _vm.completionOk,
      "ng": _vm.completionNg,
      "skip": _vm.completionSkip,
      "pathScore": _vm.currentPathScore
    },
    on: {
      "clickButton": _vm.clickButtonCompletion
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showScoreReset) ? _c('ScoreReset', {
    on: {
      "clickButton": _vm.clickScoreResetButton
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMicrophoneErrorDialog) ? _c('MicrophoneErrorDialog', {
    attrs: {
      "productInfo": _vm.productInfo
    },
    on: {
      "startLesson": _vm.startLessonFromMicErrorDialog,
      "clickMicrophoneSetting": _vm.showMicSelect,
      "lessonContinue": _vm.lessonContinue,
      "showError": _vm.emitShowError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHintDialog) ? _c('HintDialog', {
    attrs: {
      "hintText": _vm.hintText,
      "isHintHosoku": _vm.isHintHosoku
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-69dcffb2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-69dcffb2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Runmode.vue
// module id = 873
// module chunks = 1